import { Injectable } from '@angular/core';
import emailjs from 'emailjs-com';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailjsService {
  private publicKey = environment.emailjs.publicKey;
  private serviceId = environment.emailjs.serviceId;
  private templateId = environment.emailjs.templateId;

  constructor() {
    emailjs.init(this.publicKey);
  }

  async sendEmail(name: string, email: string, subject: string, message: string): Promise<unknown> {
    const templateParams = {
      name: name,
      email: email,
      subject: subject,
      message: message,
    };

    return emailjs
      .send(this.serviceId, this.templateId, templateParams)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  }
}
